import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import CreditView from 'views/Administration/UserCredits/Credit';
import ParticipantService from 'api/Participant';
import UserService from 'api/User';
import { useFetch, useSubmit } from 'hooks';
import SettingsActions from 'store/reducers/Settings';
import UserActions from 'store/reducers/User';
import { handlePromise } from 'utils';

const Credit = ( {
  parentPath, ownerCredit = 0, match, history, toggleErrorAlert, toggleLoading,
  updateUser,
} ) => {
  const entityId = match.params.id;

  const [data, dataLoading] = useFetch( {
    initialState: {},
    promise: () => ParticipantService.getParticipant( entityId ),
    toggleErrorAlert,
    deps: [entityId],
  } );

  const submitForm = useSubmit( {
    promise: ( dataToSend ) => ParticipantService.updateParticipant( entityId, dataToSend ),
    format: ( dataToFormat ) => ( { credit: dataToFormat.amount } ),
    toggleLoading,
    callback: async () => {
      toggleLoading( true );
      const [errors, response, responseData] = await handlePromise( UserService.getUser() );
      if ( !response.ok ) return toggleErrorAlert( errors );
      updateUser( responseData );
      toggleLoading( false );
      history.push( parentPath );
    },
  } );

  return (
    <CreditView
      data={data}
      parentPath={parentPath}
      isLoading={dataLoading}
      ownerCredit={ownerCredit}
      onSubmit={submitForm}
    />
  );
};

const mapStateToProps = ( { user } ) => ( {
  ownerCredit: _.get( user, 'credit' ),
} );

const mapDispatchToProps = ( {
  toggleErrorAlert: SettingsActions.toggleErrorAlert,
  toggleLoading: SettingsActions.toggleLoading,
  updateUser: UserActions.updateUser,
} );

export default connect( mapStateToProps, mapDispatchToProps )( Credit );
